import withStyles from "@material-ui/core/styles/withStyles";
import { chartGradientColors } from "assets/jss/material-dashboard-pro-react.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PropTypes from "prop-types";
import React from "react";
// @ts-ignore
import { Chart, Doughnut as DoughnutChart } from "react-chartjs-2";

const styles = ({
	circleBoxGrid: {
		width: "100%",
		textAlign: "center"
	},
	circleBox: {
		display: "inline-block",
		marginTop: "24px",
		marginLeft: "auto",
		marginRight: "auto",
		marginBottom: "24px"
	}
});

class LoanApprovalStatusChart extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
		};

		this.chartOptions = {
			maintainAspectRatio: false,
			responsive: false,
			legend: {
				display: false
			},
			cutoutPercentage: 90,
			animation: {
				duration: 2000
			},
			tooltips: { enabled: true }
		};
		this.getGradientList = this.getGradientList.bind(this);

	}

	componentDidMount() {
		this.props.setAppLeftTitle(this.props.leftTitle);
		this.props.setAppCenterTitle(this.props.centerTitle);

		var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
		Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
			draw: function () {
				originalDoughnutDraw.apply(this, arguments);

				var chart = this.chart;
				var width = chart.chart.width,
					height = chart.chart.height,
					ctx = chart.chart.ctx;

				var fontSize = 1.5;
				ctx.font = fontSize + "em sans-serif";
				ctx.textBaseline = "middle";
				ctx.fillStyle = "#000";

				var text = chart.config.data.text,
					textX = Math.round((width - ctx.measureText(text).width) / 2),
					textY = height / 2;

				ctx.fillText(text, textX, textY);

			}
		});

	}
	componentDidUpdate() {

	}
	getGradientList(dataList) {
		var gradientList = undefined;
		if (document.getElementById("canvas") != null) {
			// @ts-ignore
			var ctx = document.getElementById("canvas").getContext("2d");
			gradientList = [];
			if (dataList.datasets != undefined) {
				var i;
				for (i = 0; i < dataList.datasets[0].data.length; i++) {
					var gradient = ctx.createLinearGradient(0, 0, 0, 400);
					if (chartGradientColors[i] == undefined) {
						gradient.addColorStop(0, chartGradientColors[0].begin);
						gradient.addColorStop(1, chartGradientColors[0].end);
					} else {
						gradient.addColorStop(0, chartGradientColors[i].begin);
						gradient.addColorStop(1, chartGradientColors[i].end);
					}
					gradientList.push(gradient);
				}
				return gradientList;
			}
		}
		return;

	}
	render() {
		const { classes, TitleChart, TitleChart2, TitleChart3, onHoldChartData, approvedChartData, rejectedChartData } = this.props;

		var onHoldGradientList = this.getGradientList(onHoldChartData);
		var onHoldBackground = onHoldChartData;
		if (onHoldGradientList != undefined) {
			onHoldBackground.datasets[0].backgroundColor = onHoldGradientList;
			onHoldBackground.datasets[0].hoverBackgroundColor = onHoldGradientList;
		}
		var approvedGradientList = this.getGradientList(approvedChartData);
		var approvedBackground = approvedChartData;
		if (approvedGradientList != undefined) {
			approvedBackground.datasets[0].backgroundColor = approvedGradientList;
			approvedBackground.datasets[0].hoverBackgroundColor = approvedGradientList;
		}
		var declinedGradientList = this.getGradientList(rejectedChartData);
		var declinedBackground = rejectedChartData;
		if (declinedGradientList != undefined) {
			declinedBackground.datasets[0].backgroundColor = declinedGradientList;
			declinedBackground.datasets[0].hoverBackgroundColor = declinedGradientList;
		}

		return (
			<GridContainer spacing={16}>
				<GridItem md={12} xs={12}>
					<Card>
						<CardBody>
							<GridContainer>
								<GridItem xs={4} className={classes.circleBoxGrid}>
									<div className={classes.circleBox}>
										<DoughnutChart
											// @ts-ignore
											id='canvas'
											data={onHoldBackground} width={180} height={250}
											options={onHoldBackground.text == "" || onHoldBackground.text == "0" ? { ...this.chartOptions, ...{ tooltips: { enabled: false } } } : this.chartOptions}
										/>
										<h4>{TitleChart}</h4>
									</div>
								</GridItem>
								<GridItem xs={4} className={classes.circleBoxGrid}>
									<div className={classes.circleBox}>
										<DoughnutChart data={approvedBackground} width={180} height={250}
											options={approvedBackground.text == "" || approvedBackground.text == "0" ? { ...this.chartOptions, ...{ tooltips: { enabled: false } } } : this.chartOptions}
										/>
										<h4>{TitleChart2}</h4>
									</div>
								</GridItem>
								<GridItem xs={4} className={classes.circleBoxGrid}>
									<div className={classes.circleBox}>
										<DoughnutChart data={declinedBackground} width={180} height={250}
											options={declinedBackground.text == "" || declinedBackground.text == "0" ? { ...this.chartOptions, ...{ tooltips: { enabled: false } } } : this.chartOptions}
										/>
										<h4>{TitleChart3}</h4>
									</div>
								</GridItem>
							</GridContainer>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}

LoanApprovalStatusChart.propTypes = {
	classes: PropTypes.object,
	columns: PropTypes.array,
	list: PropTypes.array,
	onHoldChartData: PropTypes.object,
	approvedChartData: PropTypes.object,
	rejectedChartData: PropTypes.object,
	leftTitle: PropTypes.string,
	centerTitle: PropTypes.string,
	TitleChart: PropTypes.string,
	TitleChart2: PropTypes.string,
	TitleChart3: PropTypes.string,
	setAppLeftTitle: PropTypes.func,
	setAppCenterTitle: PropTypes.func
};

// @ts-ignore
export default withStyles(styles)(LoanApprovalStatusChart);